export const API_URL = "https://api.ffci-guatemala.org/api/v1";
Object.freeze(API_URL);

export const PASS_PATTERN = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).+$/;
Object.freeze(PASS_PATTERN);

export const ROLE = {
  ADMIN: "admin",
  USER: "usuario",
  OPERATOR: "operador",
  CONSULTANT: "asesor"
};
Object.freeze(ROLE);

export const FILE_TYPE = {
  DPI: "DPI",
  RECORD: "RECORD",
  ESTADO: "ESTADO",
  ACUERDO: "ACUERDO",
  PODER: "PODER",
  PERSONAL: "PERSONAL"
};
Object.freeze(FILE_TYPE);

export const REQUIRED_DOCS = [FILE_TYPE.DPI, FILE_TYPE.RECORD, FILE_TYPE.ESTADO, FILE_TYPE.PODER];
Object.freeze(REQUIRED_DOCS);

export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const DOC_HELP = {
  [FILE_TYPE.DPI]: {
    label: "Documento de Identificación",
    shortLabel: "Identificación",
    description: "Tu Documento Personal de Identificación (DPI).",
    instructions: "Escanea o toma una fotografía clara de ambos lados de tu DPI.",
    templateKey: null,
    externalLink: null
  },
  [FILE_TYPE.RECORD]: {
    label: "Record Crediticio",
    shortLabel: "Record Crediticio",
    description:
      "Reporte de la Superintendencia de Bancos con el registro de todos tus créditos solicitados.",
    instructions:
      "Solicítalo en el Portal de Atención al Usuario de la Superintendencia de Bancos, a través de tu banca en línea, o presentándote en sus oficinas.",
    templateKey: null,
    externalLink: "https://www.sib.gob.gt"
  },
  [FILE_TYPE.PODER]: {
    label: "Carta de Autorización",
    shortLabel: "Carta Autorización",
    description: "Nos permite realizar negociaciones de créditos en tu nombre.",
    instructions: "Descarga la plantilla, completa los espacios con tu información y cárgala firmada.",
    templateKey: "CartaAutorizacion"
  },
  [FILE_TYPE.ESTADO]: {
    label: "Estado de Cuenta",
    shortLabel: "Estado de Cuenta",
    description:
      "Documento mensual emitido por tu banco con todos los movimientos de tus cuentas.",
    instructions:
      "Generalmente es enviado a tu correo electrónico. También puedes solicitarlo en servicio al cliente de tu banco.",
    templateKey: null
  },
  [FILE_TYPE.ACUERDO]: {
    label: "Reconocimiento de Deuda",
    shortLabel: "Reconocimiento",
    description: "Documento donde se reconocen y acuerdan detalles sobre el pago de deuda.",
    instructions: "Descarga la plantilla, completa los espacios vacíos y cárgalo.",
    templateKey: "Reconocimiento"
  },
  [FILE_TYPE.PERSONAL]: {
    label: "Documento solicitado por la asesoría",
    shortLabel: "Documento Asesoría",
    description:
      "Documentos adicionales que tu asesor puede solicitar durante tu proceso, como presupuesto, análisis de créditos o control de gastos.",
    instructions: null,
    templateKey: null
  }
};
Object.freeze(DOC_HELP);

export const debtReasons = [
  { label: "No sabe tomar decisiones inteligentes", id: "noDecisions", value: false },
  { label: "No sabe administrarse", id: "noAdministration", value: false },
  { label: "No sabe decir NO", id: "noNo", value: false },
  { label: "No tiene presupuesto", id: "noBudget", value: false },
  { label: "No tiene control de gastos", id: "noSpendControl", value: false },
  { label: "Es muy complaciente", id: "indulging", value: false },
  { label: "Gastos hormiga sin control", id: "antSpending", value: false },
  { label: "Tiene espíritu de salvador(a)", id: "saviour", value: false },
  { label: "Tiene desorden en su economía", id: "unordered", value: false },
  { label: "Un estilo de vida no razonable", id: "lifestyle", value: false },
  { label: "Mantiene ansiedad", id: "anxiety", value: false },
  { label: "Problemas de salud", id: "health", value: false },
  { label: "Presume del futuro", id: "future", value: false },
  { label: "No ha tomado un curso de educación financiera", id: "education", value: false }
];

Object.freeze(debtReasons);
